<template>
    <div class="top">
        <h1>Чемпион</h1>

        <div>
            <p>Программа страхования от несчастных случаев - это финансовая поддержка при наступлении несчастного случая при занятиях спортом. Программа подойдет для тех, кто занимается спортом, участвует в соревнованиях или ведет активный образ жизни.</p>
            <!-- <p><b>21% скидка по промокоду MLНам21 или по карте москвича/петербуржца</b></p> -->
        </div>
        <div>
            <Button label="Рассчитать" className="confirm" @click="this.$refs.calculation.scrollIntoView({ behavior: 'smooth'})"/>
            <Button label="Подробнее" className="infomation" @click="this.$refs.advantages.scrollIntoView({ behavior: 'smooth'})"/>
        </div>
    </div>

    <div class="content__container calculation" ref="calculation">
        <div class="calculation__left">
            <h2>Быстрый расчет</h2>

            <div class="calculation__block">
                <p>Возраст застрахованных</p>
                <div class="calculation__selectors">
                    <Button v-for="(item, index) in ageOptions" :label="item.text" :className="item.class" @click="selectHandler(item, index, 'age', 'ageOptions')"/>
                </div>

                <p>Срок страхования</p>
                <div class="calculation__selectors">
                    <Button v-for="(item, index) in durationOptions" :label="item.text" :className="item.class" @click="selectHandler(item, index, 'duration', 'durationOptions')"/>
                    
                </div>

                <p>Дата начала</p>
                <div class="calculation__selectors gap">
                    <Input type="date" v-model="contractStore.champion.startDate" :error="dateStartErrors" />
                    <Input type="date" v-model="contractStore.champion.endDate" :error="dateEndErrors" v-if="duration === 'Меньше месяца'"/>
                    <span v-if="duration === 'Меньше месяца'">дней: {{ contractStore.dateRange }}</span>
                </div>

                <div></div>
                <p>Вид спорта</p>
                <Select2 v-model="contractStore.champion.chosenSports" :options="sportOptions" :settings="{ multiple: true, width: '100%' }" />
                
                <span class="blue-text">Также застрахованы виды спорта, входящие в ту же рисковую <strong :style="{cursor: 'pointer'}" @click="openDialog()">Категорию</strong>, что и выбранные.</span>

                <p>Страховая сумма</p>
                <input type="range" v-model="safeSum" @input="sumStep" min="50000" max="500000" step="90000" list="markers" />
                <datalist id="markers">
                    <option value="50000" label="50000" @click="safeSum = '50000', sumStep()"></option>
                    <option value="140000" label="100000" @click="safeSum = '140000', sumStep()"></option>
                    <option value="230000" label="200000" @click="safeSum = '230000', sumStep()"></option>
                    <option value="320000" label="300000" @click="safeSum = '320000', sumStep()"></option>
                    <option value="410000" label="400000" @click="safeSum = '410000', sumStep()"></option>
                    <option value="500000" label="500000" @click="safeSum = '500000', sumStep()"></option>
                </datalist>
            </div>
        </div>

        <div class="calculation__right">
            <h3>Стоимость полиса</h3>

            <div class="wrapper"></div>

            <span>Возраст застрахованных</span>
            <Input :disabled="true" v-model="age" />
            <span>Срок страхования</span>
            <Input :disabled="true" v-model="duration" />
            <span>Виды спорта</span>
            <Input :disabled="true" v-model="selectedSports" />
            <span>Страховая сумма</span>
            <Input :disabled="true" v-model="contractStore.champion.sumStep" />

            <p>{{ contractStore.price }} ₽</p>
            <Button 
                label="Оформить"
                className="confirm"
                @click="$router.push('/athletes/registration')"
                :disabled="!contractStore.price || !!dateStartErrors || !!dateEndErrors"
            />
        </div>
    </div>

    <div class="content__container advantages" ref="advantages">
        <div class="advantages__block">
            <img src="../assets/images/Icon_Preimushestva_Shirokiy_spektr.png" alt="">
            <p>Широкий спектр <br> покрываемых рисков</p>
        </div>
        <div class="advantages__block">
            <img src="../assets/images/Icon_Preimushestva_Strah_zashita.png" alt="">
            <p>Страховая защита <br> 24/7</p>
        </div>
        <div class="advantages__block">
            <img src="../assets/images/Icon_Preimushestva_Zashita_po_miru.png" alt="">
            <p>Защита <br> по всему миру</p>
        </div>
        <div class="advantages__block">
            <img src="../assets/images/Icon_Preimushestva-min_paket_doc.png" alt="">
            <p>Отсутствие <br> документов</p>
        </div>
    </div>

    <div class="content__container champion">
        <h2>Чемпион</h2>
        <p>Занятия спортом связаны с повышенным риском. Спортсмены во время тренировок и соревнований испытывают значительные физические нагрузки. Получить травмы могут как новички, так и опытные спортсмены. Страховая компания "МАКС-Жизнь" предлагает специальную программу страхования "Чемпион", позволяющую предупредить финансовые потери при возникновении непредвиденных ситуаций тем, кто занимается спортом, участвует в соревнованиях или ведет активный образ жизни.</p>
    </div>

    <div class="content__container program">
        <h2>Как оформить программу</h2>
        <div>
            <div class="program__block">
                <img src="../assets/images/IMG_Shagi_1.png" alt="">
                <p>Выберите параметры страхования и рассчитайте стоимость полиса</p>
            </div>
            <div class="program__block">
                <img src="../assets/images/IMG_Shagi_2.png" alt="">
                <p>Заполните все необходимые данные, оформите и оплатите полис онлайн</p>
            </div>
            <div class="program__block">
                <img src="../assets/images/IMG_Shagi_3.png" alt="">
                <p>Получите полис по адресу электронной почты, указанному при оформлении</p>
            </div>
        </div>
    </div>

    <div class="content__container description">
        <Tabs :items="['Условия программы', 'Страховые риски']" @click="setActiveProgrammTab"/>
        <div class="description__block">
            <div v-for="(item, index) in programmItems[programmTabIndex]">
                <span :class="{'full': programmTabIndex === 1}"><strong>{{ item.title }}</strong></span>
                <span v-if="item.value">{{ item.value }}</span>
            </div>

        </div>
    </div>

    <div class="content__container description">
        <Tabs :items="['Широкий спектр покрываемых рисков', '24/7', 'Защита по всему миру', 'Отсутствие документов']" @click="setActiveDescriptionTab"/>
        <div class="description__info">
            <p>{{ descriptionItems[descriptionTabIndex] }}</p>
            <span v-if="descriptionTabIndex === 2">* За исключением зон вооруженных конфликтов.</span>
        </div>
    </div>

    <div class="content__container actions">
        <a class="actions__calc">
            <Button label="Рассчитать" className="confirm" @click="this.$refs.calculation.scrollIntoView({ behavior: 'smooth'})"/>
        </a>

        <div class="actions__contacts">
            <h4>Остались вопросы по программе страхования?</h4>
            <p>Позвоните 8 800 333 90 13 или оставьте свои контактные данные, мы свяжемся с вами и проконсультируем</p>

            <div class="contacts__inputs">
                <Input placeholder="Имя" v-model="infoForBackCall.name" />
                <Input placeholder="Номер телефона" v-model="infoForBackCall.phone" type="tel" />
                <Input placeholder="Город" v-model="infoForBackCall.city" />
            </div>

            <div class="contacts__call">
                <Button label="Перезвонить мне" className="confirm"/>
            </div>

            <p>Отправляя заявку, вы соглашаетесь с правилами обработки
                <a href="/upload/medialibrary/2b2/PolitikaPD.pdf" target="_blank">персональных данных</a>
            </p>
        </div>
    </div>

    <!-- моадаль с категориями -->
    <ClpDialog :show=showDialog @close="showDialog=false">
        <div class="modal__container">
            <div class="modal__top">
                <h3>Категории</h3>
                <img src="../assets/icons/cross.svg" alt="" @click="showDialog=false">
            </div>
            <div class="modal__content">
                <div class="modal__block">
                    <h4>Категория 1:</h4>
                    <p>Авиамодельный спорт, Автомодельный спорт, Активный отдых, Армрестлинг, Армспорт, Аэробика, Баскетбол интерактивный, Бильярдный спорт, Бодибилдинг, Бокс интерактивный, Бочче, Бридж, Го, Городошный спорт, Дартс, Киберспорт, Кинологический спорт, Компьютерный спорт, Лазертаг, Летний лагерь, Нарды, Парусный спорт (радиоуправляемая яхта), Перетягивание каната, Петанк, Покер, Радиоспорт, Рыбалка (в том числе зимняя), Рыболовный спорт, Спортивная ходьба, Спортивно-прикладное собаководство, Судомодельный спорт, Таврели, Теннис настольный, Футбол интерактивный, Ходьба скандинавская, Хореография, Шахматы, Шашки, Экскурсии</p>
                </div>
                <div class="modal__block">
                    <h4>Категория 2:</h4>
                    <p>Айсшток, Ачери, Аэробика спортивная, Аэройога, Аэротруба, Бадминтон, Балет, Бег, Бег с барьерами; Бег с препятствиями; Кросс легкоатлетический, Бейсбол, Биатлон, Боулинг, Брейк-данс, Водное поло, Воздухоплавательный спорт (аэростаты, дирижабли), Воздушно-силовая атлетика, Воркаут, Гимнастика художественная, Гимнастика эстетическая, Гиревой спорт, Гольф, Гребля академическая, Гребля на байдарках и каноэ, Гребля на шлюпках, Ездовой спорт, Йога, Кёрлинг, Крикет, Крокет, Кроссфит, Лапта, Легкая атлетика, Мас-рестлинг, Метание диска, Метание копья, Метание молота, Метание ножа, Метание ядра, Падел, Пауэрлифтинг, Пейнтбол, Плавание, Пол-дэнс, Практическая стрельба, Прыжки в воду (бассейн), Прыжки в высоту, Прыжки в длину, Прыжки с шестом, Прыжок тройной, Пулевая стрельба, Роллер спорт трек, Роуп скиппинг (спортивная скакалка), Синхронное плавание, Сквош, Софтбол, Сплав на байдарках по рекам, Спортивная стрельба, Спортивное ориентирование (кросс), Спортивные танцы, Спортивный туризм (лыжный и пеший), Стендовая стрельба, Стрельба из арбалета, Стрельба из лука, Танцевальный спорт, Танцы бальные, Танцы современные, Теннис, Толкание ядра, Фехтование (рапира, шпага), Фитнес, Фитнес-аэробика, Флаинг диск, Футгольф, Хип – хоп, Ходьба</p>
                </div>
                <div class="modal__block">
                    <h4>Категория 3:</h4>
                    <p>SUP-сёрфинг, Акробатический рок-н-ролл, Атлетика тяжелая, Беговые лыжи, Борьба на поясах, Буерный спорт, Велосипедный спорт (велокрос), Водно-моторный спорт, Волейбол, Гимнастика спортивная, Гонки на охотничьих лыжах, Горный треккинг, Гребной слалом, Дуатлон, Кануполо (Канополо), Каякинг, Конный спорт (за исключением родео), Конькобежный спорт, Корфбол, Легкая атлетика многоборье, Лыжероллеры (биатлон, лыжные гонки), Лыжные гонки, Морское многоборье, Мотобол, Парусный спорт, Пляжный волейбол, Пожарно-прикладной спорт, Прыжки на батуте, Скалолазание на искусственном рельефе, Спасательный спорт, Спортивное ориентирование (лыжи), Страйкбол (аирсофт), Треккинг, Триатлон, Фехтование (сабля), Фигурное управление мотоциклом, Чир спорт, Чирлидинг (Черлидинг), Якутские национальные прыжки, Яхтинг</p>
                </div>
                <div class="modal__block">
                    <h4>Категория 4:</h4>
                    <p>Автомобильный спорт дрифт, Айкидо, Акробатика спортивная, Армейский рукопашный бой, Армлифтинг, Арнис, Баскетбол, Бобслей, Бодирафтинг, Бодисёрфинг, Бокс, Велосипед горный, Велосипедный спорт трек, Велосипедный спорт шоссе, Виндсёрфинг, Водно-спасательное многоборье, Воднолыжный спорт, Восточное боевое единоборство, Всестилевое каратэ, Вьет во дао, Гандбол, Гонки с препятствиями, Горные лыжи (катание по подготовленным спускам), Гребно-парусное двоеборье, Дайвинг до 40 метров, Двоеборье, Джиу-джитсу, Дзэндо, Дзюдо, Индорхоккей, Кайтсёрфинг, Капоэйра, Каратэ, Картинг, Кендо (Кэндо), Керешу, Кикбоксинг, Киокусинкай, Кобудо, Комплексное единоборство, Корэш, Крав-мага, Кудо, Кунг-фу, Кураш, Кэмпо, Легкая атлетика (горный бег, трейл), Лонгборд, Лыжное двоеборье, Международное военно-спортивное многоборье, Мини-футбол, Многоборье, Охота, Пляжный футбол, Подводный спорт (подводное плавание), Полиатлон, Про-амат, Прыжки в воду (открытый водоем), Пятиборье, Рафтинг, Регби, Регбол, Рогейн, Роллер спорт, Рукопашный бой, Сёрфинг, Сётокан, Сават, Самбо, Самокатный спорт, Санный спорт, Саньда, Свимран, Северное многоборье, Силовое троеборье, Силовой экстрим, Сито-рю, Скайраннинг, Скейтборд, Скиборд, Смешанное боевое единоборство (ММА), Сноуборд, Спортивная борьба (вольная, греко-римская, грэпплинг, панкратион), Спортивное ориентирование (велокросс), Спортивный туризм (водный и горный), Сумо, Тайский бокс (Муай Тай), Таолу, Триатлон (акватлон), Троеборье, Тхэквондо (Тэквондо), Универсальный бой, Ушу, Фигурное катание, Флаг-футбол, Флорбол, Фриран, Функциональное многоборье, Футбол, Футбол американский, Хапкидо, Хапсагай, Хоккей, Хоккей на траве, Хоккей с мячом, Хуреш, Чой кван до, Шодсанлат, Юнчуньцюань</p>
                </div>
            </div>
        </div>
    </ClpDialog>
</template>

<script>
import { useContractsStore } from '@/create/store/contracts';
import Button from '@/create/components/UI/buttons/Button.vue';
import Input from '@/create/components/UI/inputs/Input.vue';
import Tabs from '@/create/components/UI/list/Tabs.vue';
import Select2 from 'vue3-select2-component';
import { dateFormatter } from '@/create/composables/utils';
import ClpDialog from "@/create/components/ClpDialog.vue";

export default {
    components: {
        Button,
        Input,
        Tabs,
        Select2,
        ClpDialog,
    },
    data() {
        return {
            contractStore: useContractsStore(),
            age: '3-17 лет',
            ageOptions: [
                {text: '3-17 лет', class: 'select active'},
                {text: '18-65 лет', class: 'select'},
            ],
            duration: '1 месяц',
            durationOptions: [
                {text: 'Меньше месяца', class: 'select'},
                {text: '1 месяц', class: 'select active'},
                {text: '3 месяца', class: 'select'},
                {text: '6 месяцев', class: 'select'},
                {text: '1 год', class: 'select'},
            ],
            sportOptions: [],
            safeSum: "300000",
            programmTabIndex: 0,
            programmItems: [
                [
                    {
                        title: "Срок страхования",
                        value: "От 1 дня до 1 года"
                    },
                    {
                        title: "Возраст застрахованного",
                        value: "От 3 до 65 лет на дату заключения договора"
                    },
                    {
                        title: "Количество застрахованных",
                        value: "До 30 человек"
                    },
                    {
                        title: "Страхователь",
                        value: "От 18 лет"
                    },
                    {
                        title: "Страховая сумма",
                        value: "От 50 000 руб."
                    },
                    {
                        title: "Действие программы",
                        value: "24/7"
                    },
                    {
                        title: "Территория страхования",
                        value: "Весь мир"
                    },
                    {
                        title: "Периодичность взносов",
                        value: "Единовременно (в день заключения договора)"
                    },
                ],
                [
                    {
                        title: "Уход из жизни в результате несчастного случая",
                        value: ""
                    },
                    {
                        title: "Инвалидность в результате несчастного случая",
                        value: ""
                    },
                    {
                        title: "Травма в результате несчастного случая",
                        value: ""
                    },
                ],
            ],
            descriptionTabIndex: 0,
            descriptionItems: [
                "Программа покрывает самые распространенные риски: травмы, полученные в результате несчастного случая, в том числе при занятиях спортом, инвалидность 1, 2 и 3 группы и уход из жизни в результате несчастного случая.",
                "Программа действует круглосуточно в течение срока действия договора страхования.",
                "Программа действует как защита от несчастного случая в любой точке мира.*",
                "Для оформления договора страхования вам понадобятся только фамилии, имена и даты рождения страхователя и всех застрахованных."
            ],
            infoForBackCall: {},                                                    // объект с инфой для обратной связи 
            calculationProcess: false,
            errors: {},
            showDialog: false
        }
    },
    computed: {
        selectedSports() {                      // перечисление видов спортов через запятую, используется справа в карточке на 1 странице оформления
            const arr = this.sportOptions.filter(i => this.contractStore.champion.chosenSports.includes(i.id)).map(i => i.text)
            const str = arr.join(', ')
            return str
        },
        dateStartErrors() {
            const d = this.contractStore.champion.startDate.split('-').join('.')
            if ((new Date(d).getTime() - new Date(new Date).getTime()) < 1000) return 'Дата не должна быть раньше завтрашнего дня'
            return ''
        },
        dateEndErrors() {
            if (this.contractStore.dateRange > 30 && this.duration === 'Меньше месяца') return 'Дата окончания не может быть более, чем 30 дней от даты начала'
            if (this.contractStore.dateRange < 1) return 'Дата окончания не может быть ранее даты начала'
            return ''
        }
    },
    methods: {
        sumStep() {                 // для выравнивания ползунка ему были заданы иные значения, а возвращается сумма страхования
            if (this.safeSum === '50000') return this.contractStore.champion.sumStep = this.safeSum
            if (this.safeSum === '140000') return this.contractStore.champion.sumStep = '100000'
            if (this.safeSum === '230000') return this.contractStore.champion.sumStep = '200000'
            if (this.safeSum === '320000') return this.contractStore.champion.sumStep = '300000'
            if (this.safeSum === '410000') return this.contractStore.champion.sumStep = '400000'
            if (this.safeSum === '500000') return this.contractStore.champion.sumStep = this.safeSum
            return '300000'
        },
        setActiveProgrammTab(idx) {
            this.programmTabIndex = idx
        },
        setActiveDescriptionTab(idx) {
            this.descriptionTabIndex = idx
        },
        selectHandler(item, index, field, refArray) {                   // общая функция для псевдо радиокнопок,
            this[field] = item.text                                     // указывается переменная для отслеживания field
            this[refArray].forEach(i => i.class = 'select')             // и массив значений refArray
            this[refArray][index].class = 'select active'
        },
        async getSportOptions() {                                       // список видов спорта с бека
            this.sportOptions = await this.contractStore.getSports({
                    format: "json",
                    action: "get_sports_list",
                    ver: 4,
                    object: "contract",
                    login: "bodyguard",
                }
            );
        },
        async getCalculation() {                                        // предварительный расчет
            const data = {
                format: "json",
                action: "calc",
                ver: 4,
                object: "contract",
                login: "bodyguard",
                agreement: {
                    program_type: "cred",
                    program: "sport",
                    ins_calc_amount: this.contractStore.champion.sumStep,
                    ins_calc_type: "1",
                    ins_period: this.contractStore.champion.durationTerm,
                    payment_order: "0",
                    currency: "rur",
                    insurer: 0,
                    insured: "1",
                    status: 10,
                    bank_policy_premium: 0,
                    menu_id: "10",
                    insured_birth_date: this.age === '3-17 лет' ? '01.01.2020' : '01.01.2005',
                    date_start: dateFormatter('-', this.contractStore.champion.startDate),
                    discount: "N",
                    discount_card: "",
                    kinds_of_sports: this.contractStore.champion.chosenSports,
                }
            }

            try {
                const res = await this.contractStore.getCalculation(data)
                this.contractStore.price = +res.data.ins_fee
                if (res.data.contract_date_end) this.contractStore.champion.endDate = dateFormatter('.', res.data.contract_date_end)
            } catch (error) {
                console.log(error);
            }
        },
        openDialog() {
            this.showDialog = true;
            setTimeout(() => {
                document.querySelector('.clp-dialog').focus();
            }, 100)
        }
    },
    mounted() {
        const date = new Date()
        this.contractStore.champion.startDate = new Date(date.getTime() + (1 * 24 * 60 * 60 * 1000)).toISOString().slice(0, 10);

        this.getSportOptions()

        this.$watch(vm => [vm.age, vm.contractStore.champion], async() => {                   // постоянно отслеживаем изменения формы для калькуляции
            localStorage.setItem('contract', JSON.stringify(this.contractStore.champion))

            if (this.contractStore.champion.chosenSports.length == 0 || this.calculationProcess) return
            else {
                this.calculationProcess = true
                await this.getCalculation()
                this.calculationProcess = false
            }
        }, {
            immediate: true,
            deep: true
        })

        window.document.head.getElementsByTagName('title')[0].innerHTML = 'Чемпион'
    },
    watch: {
        duration() {                                    // отслеживаем период и устанавливаем разницу дат
            const date = new Date()
            if (this.duration === 'Меньше месяца') {
                this.contractStore.champion.endDate = new Date(date.getTime() + (15 * 24 * 60 * 60 * 1000)).toISOString().slice(0, 10);
                this.contractStore.champion.durationTerm = this.contractStore.dateRange + 'D'
            }
            else if (this.duration === '1 год') this.contractStore.champion.durationTerm = '12M'
            else this.contractStore.champion.durationTerm = this.duration.slice(0, 1) + 'M'
        },
        'contractStore.champion.startDate'() {            // дополнительно отслеживаем и устанавливаем конечную дату, если период меньше месяца
            if (this.duration === 'Меньше месяца') this.contractStore.champion.durationTerm = this.contractStore.dateRange + 'D'
        },
        'contractStore.champion.endDate'() {            // дополнительно отслеживаем и устанавливаем конечную дату, если период меньше месяца
            if (this.duration === 'Меньше месяца') this.contractStore.champion.durationTerm = this.contractStore.dateRange + 'D'
        }
    }
}
</script>

<style lang="scss" scoped>
h2 {
    font-weight: 700;
    font-size: 1.5rem;
}

.top {
    background-image: url('../assets/images/Img_Banner_telohranitel_sport_\(1920x615\).jpg');
    background-size: cover;
    width: 100%;
    height: 700px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    padding-left: 50%;
    padding-right: 5%;
    background-position: left center;

    @media (max-width: 480px) {
        height: 262px;
        padding: 10px;
        justify-content: space-between;
        background-position: -50px;

        h1 {
            color: white;
            position: absolute;
        }

        p {
            font-size: .5rem;
            width: calc(43vw - 6px);
            line-height: .875rem;
            align-self: end;
        }
    }

    div:nth-child(2) {
        display: flex;
        flex-direction: column;
        gap: 20px;

        @media (max-width: 480px) {
            gap: 10px;
        }
    }

    div:nth-child(3) {
        display: flex;
        gap: 100px;

        @media (max-width: 480px) {
            gap: 40px;
            justify-content: space-between;
        }
    }
}

.calculation {
    margin-top: 55px;
    padding: 50px 25px;
    display: flex;
    gap: 60px;
    background-color: #f2f3f5;

    @media (max-width: 480px) {
        margin-top: 30px;
        padding: 20px 10px;
        flex-direction: column;
        gap: 20px;
    }

    &__left {
        width: 70%;

        @media (max-width: 480px) {
            width: 100%;
        }

        h2 {
            margin-bottom: 10px;
        }
    }


    &__block {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }
    
    &__selectors {
        display: flex;
        align-items: center;

        @media (max-width: 480px) {
            flex-wrap: wrap;
            gap: 10px;
            justify-content: space-between;
        }
    
        &.gap {
            gap: 10px;

            .input__container {
                width: 250px;

                @media (max-width: 480px) {
                    width: 100%;
                }
            }
        }
    
        button {
            width: max-content;
            min-width: 100px;

            @media (max-width: 480px) {
                flex-grow: 1;
                max-width: 48%;
            }
        }
    }

    &__right {
        display: flex;
        flex-direction: column;
        gap: 10px;
        background-color: white;
        border-left: 1px solid gainsboro;
        border-right: 1px solid gainsboro;
        padding: 20px;

        h3 {
            font-size: 1rem;
            font-weight: 700;
            color: #00509f;
            text-align: center
        }

        span {
            font-size: 0.75rem;
            color: #a8abb0;
        }
        
        p {
            margin: 5px 0;
            text-align: center;
            font-size: 2rem;
            font-weight: 700;
            color: #00509f;
        }

        .input__container {
            width: 100%;
        }

        @media (max-width: 480px) {
            button {
                width: 100%;
            }
        }
    }
}

.advantages {
    margin-top: 55px;
    display: flex;
    gap: 10px;

    @media (max-width: 480px) {
        margin-top: 30px;
        padding: 0 10px;
        flex-wrap: wrap;
    }

    &__block {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        flex-grow: 1;
        gap: 10px;
        padding: 20px;
        border: 1px solid gainsboro;

        @media (max-width: 480px) {
            max-width: 48%;
        }

        img {
            width: 40%;
            vertical-align: middle;
        }

        p {
            font-size: 0.75rem;
            font-weight: 700;
            text-align: center
        }
    }
}

.champion {
    margin-top: 55px;

    @media (max-width: 480px) {
        margin-top: 30px;
        padding: 0 10px;
        text-align: justify;
    }

    p {
        margin-top: 20px;
    }
}

.program {
    margin-top: 55px;

    @media (max-width: 480px) {
        margin-top: 30px;
        padding: 0 10px;
    }

    &> div {
        margin-top: 30px;
        display: flex;
        gap: 10px;

        @media (max-width: 480px) {
            flex-direction: column;
        }
    }

    &__block {
        display: flex;
        flex: 1 0 0;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        flex-grow: 1;
        gap: 10px;
        padding: 20px;
        border: 1px solid #dee2e6;
        background-color: #edfbfe;

        @media (max-width: 480px) {
            padding: 5px;
        }

        img {
            width: 85%;
            vertical-align: middle;

            @media (max-width: 480px) {
                width: 60%;
            }
        }

        p {
            font-size: 0.75rem;
            text-align: center;
            padding: 0 25px;
        }
    }
}

.description {
    margin-top: 55px;

    @media (max-width: 480px) {
        margin-top: 30px;
        padding: 0 10px;
    }

    &__block {
        margin-top: 20px;
        
        &>div:nth-child(odd) {
            background-color: #f8f9fa;
        }

        span {
            color: #212529;
            font-size: 1rem;
            font-weight: 400;
            line-height: 38px;
            display: inline-block;
            min-width: 42%;
            padding-left: 1.5rem;
            vertical-align: top;

            @media (max-width: 480px) {
                font-size: 0.75rem;
                line-height: 20px;
                width: 49%;
                padding-left: 0.8rem;         
                
                &.full {
                    width: 100%;
                }
            }
        }
    }

    &__info {
        p {
            margin-top: 20px;
            font-size: 1rem;
            font-weight: 400;

            @media (max-width: 480px) {
                font-size: 0.75rem;
                line-height: 20px;
            }
        }
        span {
            display: block;
            margin-top: 20px;
            font-size: 0.875rem;
            font-weight: 100;

            @media (max-width: 480px) {
                font-size: 0.75rem;
                line-height: 20px;
            }
        }
    }
}

.actions {
    margin-top: 80px;

    @media (max-width: 480px) {
        margin-top: 60px;
        padding: 0 10px;
    }

    &__calc {
        button {
            width: 360px;

            @media (max-width: 480px) {
                width: 100%;
            }
        }
    }

    &__contacts {
        margin-top: 40px;
        padding: 40px 15px;
        display: flex;
        flex-direction: column;
        gap: 30px;
        background-image: url('../assets/images/Обратная_связь_1920x800.jpg');
        background-size: cover;
        background-position: center;

        @media (max-width: 480px) {
            margin-top: 30px;
            padding: 20px 10px;
            background-size: auto 100%;
            background-position: 84% 0px;
        }

        h4, p {
            margin: 0;
            font-size: 1rem;
            font-weight: 400;
            color: #212529;
        }

        h4 {
            font-weight: 700;
        }

        a {
            color: #212529;
            text-decoration: underline;
        }
    }
}

.contacts__inputs {
    display: flex;
    gap: 20px;

    @media (max-width: 480px) {
        flex-direction: column;
    }
}

.contacts__call {
    button {
        width: 345px;

        @media (max-width: 480px) {
            width: 100%;
        }
    }
}

.blue-text {
    color: #00509f;
}

.wrapper {
    width: 100%;
    height: 2px;
    background-color: gainsboro;
}

datalist {
  display: flex;
  justify-content: space-between;

  option {
    cursor: pointer;

    @media (max-width: 480px) {
        font-size: 3vw;
    }
  }
}

:deep(.clp-dialog__content) {
    width: 600px;
    max-height: 80%;
}

.modal {
    &__container {
        padding: 20px;
        position: relative;
    }

    &__top {
        display: flex;
        justify-content: space-between;
        h3 {
            font-size: 1.25rem;
        }
        img {
            width: 32px;
            cursor: pointer;
        }
    }

    &__content {
        height: 590px;
        overflow: auto;
        margin-top: 10px;
    }

    &__block {
        h4 {
            margin: 10px 0;
        }
        padding-bottom: 10px;
        border-bottom: 1px solid rgba(121, 120, 120, 0.1);

    }
}
</style>